import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=7614c2d0&scoped=true&"
var script = {}
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=7614c2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7614c2d0",
  null
  
)

export default component.exports